export default "__VITE_ASSET__CCb16ZVS__"